import { Dialog } from 'primereact/dialog'
import Button from '../../../components/ui/Button'

interface ConfirmCardProps {
  visible: boolean
  title: string
  message: string
  /** Figma: body üstünde mavi "PNR - Yolcu" satırı (Reddet popup'ı gibi). */
  subtitle?: string
  confirmLabel: string
  /** Onay butonu tonu: 'ok' (yeşil, onay) · 'submit' (kırmızı/birincil). */
  tone?: 'ok' | 'submit'
  submitting?: boolean
  onConfirm: () => void
  onHide: () => void
}

/**
 * Genel onay popup'ı (013 migrasyon: PrimeReact Dialog, bespoke `.pop-*` kaldırıldı). Tutarlı
 * Header/Body/Footer; tekil ve toplu onay için kullanılır (liste ekranı).
 */
export default function ConfirmCard({
  visible,
  title,
  message,
  subtitle,
  confirmLabel,
  tone = 'submit',
  submitting = false,
  onConfirm,
  onHide,
}: Readonly<ConfirmCardProps>) {
  const footer = (
    <div className="ui-dialog-footer">
      <Button
        label={confirmLabel}
        severity={tone === 'ok' ? 'success' : undefined}
        onClick={onConfirm}
        loading={submitting}
      />
    </div>
  )

  return (
    <Dialog
      visible={visible}
      className="confirm-dialog"
      header={title}
      footer={footer}
      onHide={onHide}
      modal
      dismissableMask={!submitting}
      closeOnEscape={!submitting}
      closable={!submitting}
      draggable={false}
      style={{ width: '22rem', maxWidth: '92vw' }}
    >
      {subtitle && <p className="pop-subtitle">{subtitle}</p>}
      <div className="pop-msg">{message}</div>
    </Dialog>
  )
}
